import { t } from 'i18next';
import { ReactComponent as ArrowRightIcon } from '../../icons/arrow.right.svg';

export default function ReportLocationEventBox({ onClick }: { onClick: () => void }) {
  return (
    <div className="mt-[20px] mb-4 w-full flex justify-center" onClick={() => onClick()}>
      <div
        className="flex flex-col w-full max-w-[400px] px-[20px] py-[14px] rounded-[12px]
                   border border-separator-light-1 dark:border-separator-dark-1"
      >
        <div className="text-[13px] font-semibold text-main-light-2 dark:text-main-dark-2 mb-[4px]">
          {t('ReportLocationEventBox.title')}
        </div>
        <div className="text-[13px] font-normal text-main-light-4 dark:text-main-dark-4 mb-[7px]">
          {t('ReportLocationEventBox.description')}
        </div>
        <button
          type="button"
          className="text-[12px] font-normal text-textPrimary-light dark:text-textPrimary-dark w-fit flex flex-row items-center gap-[4px]"
        >
          {t('ReportLocationEventBox.button')}
          <ArrowRightIcon width={12} height={12} className="inline-block" />
        </button>
      </div>
    </div>
  );
}
